import React from 'react';
import { Footer, StickyWrapper } from '..';
import { doLogin } from '../../hooks';
import { configService } from '../../services';
import i18n from "../../i18n"
import { Helmet } from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.min.css';
import { LanguageSelector } from '../Translate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';


export const LoginTile: React.FC = () => {

  const config = configService.current();
  const appId = process.env.REACT_APP_CLIENTID;
  const t = i18n.t;

  if (["zebratechnologies", "ricoh-rewards"].includes(appId as string)) {
    return <>
      <Helmet>
        <title>{configService.current().applicationTitle} | {t("page_title_login")}</title>
      </Helmet>
      <div className='login-page'>
        <div className='d-flex flex-column justify-content-between align-items-center'>
          <div className='container d-flex justify-content-end p-3'>
            <div className='menu_desktop'>
              <LanguageSelector />
            </div>
          </div>

          <div className='d-flex flex-column justify-content-between align-items-center gap-4'>
            {t("login_welcome_message")}
            <img src="/images/zebratechnologies/Zebra_EMEA_Logo_large.png" loading="lazy" className="cmp-image__image" alt="Zebra Technologies" />
            <button className='btn btn-primary m-x-05 text-decoration-none' onClick={() => doLogin()}>{t("user_login")} <FontAwesomeIcon icon={faAngleRight} /></button>
          </div>

          <Footer />
        </div>
      </div>
    </>
  }


  if (["acmetechpep"].includes(appId as string)) {
    return <>
      <Helmet>
        <title>{configService.current().applicationTitle} | {t("page_title_login")}</title>
      </Helmet>
      <div className='login-page'>
        <div className='d-flex flex-column justify-content-between align-items-center'>
          <div className='container d-flex justify-content-end p-3'>
            <div className='menu_desktop'>
              <LanguageSelector />
            </div>
          </div>

          <div className='d-flex flex-column justify-content-between align-items-center gap-4'>
            {t("login_welcome_message")}
            <img src="/images/zebratechnologies/Zebra_EMEA_Logo_large.png" loading="lazy" className="cmp-image__image" alt="Zebra Technologies" />
            <button className='btn btn-primary m-x-05 text-decoration-none' onClick={() => doLogin()}>{t("user_login")} <FontAwesomeIcon icon={faAngleRight} /></button>
          </div>

          <Footer />
        </div>
      </div>
    </>
  }


  return (
    <StickyWrapper>
      <div className='card p-top-1 p-bottom-2'>
        <div className='d-flex flex-column align-items-center'>
          <div className='text-center'>
            <h3>Join {configService.current().applicationTitle}</h3>
            <p>Score points, earn rewards and compete against other team members for big prizes. Do you have what it takes?</p>
            <div className='d-flex align-items-center justify-content-center flex-wrap'>
              <button className='btn btn-primary m-x-05 text-decoration-none' onClick={() => doLogin()}>LOGIN</button>
              <button className='btn btn-primary btn-hollow m-x-05 text-decoration-none' onClick={() => doLogin()}>REGISTER</button>
            </div>
          </div>
        </div>
      </div>
    </StickyWrapper>
  )
}